export enum AppTextInputTypeEnum {
    TEXT = 'text',
    PASSWORD = 'password',
    EMAIL = 'email',
}
